import type { ReviewAnnotationType, ReviewCategory, SceneReviewStatus } from "../lib/types.js";
import type { IconName } from "../components/Icon.js";

export const CATEGORY_LABELS: Record<ReviewCategory, string> = {
  rewrite: "Rewrite",
  confusing: "Confusing",
  repetitive: "Repetitive",
  continuity: "Continuity",
  dialogue: "Dialogue",
  pacing: "Pacing",
  cut: "Cut",
  expand: "Expand",
  check_later: "Check later",
  keep: "Keep"
};

export const CATEGORY_ORDER: ReviewCategory[] = [
  "rewrite", "confusing", "repetitive", "continuity", "dialogue",
  "pacing", "cut", "expand", "check_later", "keep"
];

export const TYPE_LABELS: Record<ReviewAnnotationType, string> = {
  highlight: "Highlight",
  strike: "Strike",
  comment: "Comment",
  flag: "Flag",
  scene_note: "Scene note",
  page_note: "Page note"
};

export const TYPE_ICONS: Record<ReviewAnnotationType, IconName> = {
  highlight: "edit",
  strike: "minus",
  comment: "note",
  flag: "tag",
  scene_note: "file",
  page_note: "book"
};

export const STATUS_LABELS: Record<SceneReviewStatus, string> = {
  unread: "Unread",
  reviewing: "Reviewing",
  needs_changes: "Needs changes",
  reviewed: "Reviewed",
  final: "Final"
};

export const STATUS_ORDER: SceneReviewStatus[] = ["unread", "reviewing", "needs_changes", "reviewed", "final"];

/** The CSS ::highlight() registry name used to paint an annotation of a type. */
export function highlightKind(type: ReviewAnnotationType): string | null {
  switch (type) {
    case "highlight": return "review-highlight";
    case "strike": return "review-strike";
    case "comment": return "review-comment";
    case "flag": return "review-flag";
    default: return null; // scene/page notes aren't anchored to text
  }
}
